import { render, staticRenderFns } from "./RedireccionesTransaccion.vue?vue&type=template&id=bdb941c0&scoped=true"
import script from "./RedireccionesTransaccion.vue?vue&type=script&lang=js"
export * from "./RedireccionesTransaccion.vue?vue&type=script&lang=js"
import style0 from "./RedireccionesTransaccion.vue?vue&type=style&index=0&id=bdb941c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb941c0",
  null
  
)

export default component.exports